export const BASE_URL = "https://api.goda-dent.com/api/";
export const PUBLIC_URL = "https://api.goda-dent.com/";